import { ArrayInput, TextField, useRecordSelection } from "react-admin";
import { ListIterator } from "../../common/list/compact-list/ListIterator";
import resourceNames from "../../../common/data/resourceNames";
import { useEffect } from "react";
import { useForm } from "react-final-form";

interface Props {
  source: string;
  filter?: any;
}

export const VehicleSelectionList = ({ source, filter }: Props) => {
  const form = useForm();
  const [ids] = useRecordSelection(resourceNames.ADMIN_VEHICLES_VIEW);

  useEffect(() => {
    form.registerField(source, () => {}, { value: true });
  }, [form, source]);

  useEffect(() => {
    form.change(source, ids);
    console.log(form.getState());
  }, [ids, form, source]);

  return (
    <ArrayInput source={source}>
      <ListIterator
        reference={resourceNames.ADMIN_VEHICLES_VIEW}
        sort={{ field: "name", order: "asc" }}
        filter={filter}
      >
        <TextField
          source="name"
          label="resources.admin-vehicles.labels.vehicleId"
        />
      </ListIterator>
    </ArrayInput>
  );
};
